export const THROTTLE_BACKOFF_DELAYS_MS = [2000, 4000, 6000, 8000, 10000];

export const THROTTLE_STATUS_CODE = 429;
